(ns common.dev-tools.tsq
  "Very experimental alternative to the official
  TSQ devtool.

  Benefits:
  - Supports displaying cljs datastructures
  - Keeps the opened data structures state over Shadow-cljs reloads"
  (:require [cljs-bean.core :refer [->clj ->js]]
            [common.queries :refer [query-client]]
            [re-frame.db]
            [react :as react]
            [reagent-dev-tools.context :as rdt-ctx]
            [reagent-dev-tools.state :as rdt-state]
            [reagent-dev-tools.state-tree :as state-tree]
            [reagent.core :as r]))

(defn- tsq-tree [open open-fn v ks]
  (if (coll? v)
    [:ul.reagent-dev-tools__ul
     (for [[k v] (if (map? v)
                   v
                   (zipmap (range) v))
           :let [open (get open k)
                 ks (conj ks k)
                 js-query-key (->js k)]]
       [:li.reagent-dev-tools__li
        {:key (pr-str k)}
        [:span.reagent-dev-tools__li-toggle
         {:on-click #(open-fn ks false)
          :title "Toggle this collection"
          :class (when (coll? v)
                   "reagent-dev-tools__li-toggle--active")}
         (when (coll? v)
           [:span.reagent-dev-tools__li-toggle-icon
            (if open "-" "+")])
         [:span.reagent-dev-tools__strong
          {:class (state-tree/type->class k)}
          (pr-str k)]

         " "]
        (when (coll? v)
          ;; TODO: Expose in rdt
          [#'state-tree/toggle-item open open-fn v ks])

        [:button
         {:on-click (fn [_e] (.refetchQueries query-client #js {:queryKey js-query-key}))}
         "refetch"]
        [:button
         {:on-click (fn [_e] (.invalidateQueries query-client #js {:queryKey js-query-key}))}
         "invalidate"]
        [:button
         {:on-click (fn [_e] (.resetQueries query-client #js {:queryKey js-query-key}))}
         "reset"]
        [:button
         {:on-click (fn [_e] (.removeQueries query-client #js {:queryKey js-query-key}))}
         "remove"]
        ;; [:button "TODO: trigger loading"]
        ;; [:button "TODO: trigger error"]

        (when (or (not (coll? v)) open)
          ;; TODO: Expose in rdt
          [#'state-tree/tree open open-fn v ks])])]

    ;; TODO: Group "data" and query status like TSQ devtool, default data to open?
    [:pre.reagent-dev-tools__pre
     {:class (state-tree/type->class v)}
     (pr-str v)]))

(def query-cache (.getQueryCache query-client))

(defn tsq-panel [panel-opts]
  ;; Follows changes to the TSQ query cache.
  ;; This should be similar approach to what the official TSQ devtool does.
  (let [queries (.-current (react/useRef (r/atom {})))]
    (react/useEffect (fn []
                       ;; Get initial query status when devtool panel is opened
                       (doseq [^js q (.getAll query-cache)]
                         (swap! queries assoc (->clj (.-queryKey q)) (->clj (.-state q))))
                       ;; Subscribe to all TSQ updates from query-cache
                       (let [unsub (.subscribe query-cache (fn [^js q]
                                                             (swap! queries assoc (->clj (.-queryKey (.-query q))) (->clj (.-state (.-query q))))))]
                         (fn []
                           (unsub))))
                     #js [])
    [:div
     (let [k (:key panel-opts)
           open (get-in @rdt-state/dev-state [:tsq k :open])
           ;; TODO: Expose in rdt
           open-fn (fn [ks open?] (swap! rdt-state/dev-state update-in [:tsq k :open] #'state-tree/toggle ks open?))
           ratom-v @queries]
       [:div
        [:span.reagent-dev-tools__strong
         "Queries"
         [#'state-tree/toggle-item open open-fn ratom-v []]]
        [tsq-tree
         open
         open-fn
         ratom-v
         []]])]))

(defn tsq-devtool []
  [:> rdt-ctx/panel-context-consumer
   (fn [v]
     (r/as-element [:f> tsq-panel v]))])

